import { createRoot } from 'react-dom/client';
import RelatedJobsMain from './RelatedJobsMain';

const rootElement = document.getElementById('aq-jobs-related-jobs');

if (rootElement) {
  const root = createRoot(rootElement);
  const numberToShow = rootElement.getAttribute('data-count') || '6';
  const jobId = rootElement.getAttribute('data-job-id') || '';

  root.render(
    <RelatedJobsMain numberToShow={numberToShow} jobId={jobId} />,
  );
}
